import { useState } from 'react';
import { texts } from '../i18n';
import { ForgottenPasswordLink } from './ForgottenPasswordLink';
import { ResetPasswordControllerSlideIn } from './ResetPasswordController';
import { useLanguage } from 'dg-web-shared/lib/Localization.tsx';

enum Views {
    HOME = 'HOME',
    RESET_PASSWORD_FORM = 'RESET_PASSWORD_FORM',
}

export function ResetPasswordDeck({
    suggestedUsername,
}: {
    suggestedUsername: string;
}) {
    const [viewState, setViewState] = useState(Views.HOME);
    const { language } = useLanguage();

    return (
        <div>
            {viewState === Views.HOME && (
                <ForgottenPasswordLink
                    onClick={() => setViewState(Views.RESET_PASSWORD_FORM)}
                />
            )}

            {viewState === Views.RESET_PASSWORD_FORM && (
                <ResetPasswordControllerSlideIn
                    title={texts[language].resetPassword}
                    open={viewState === Views.RESET_PASSWORD_FORM}
                    onClose={() => setViewState(Views.HOME)}
                    suggestedUsername={suggestedUsername}
                />
            )}
        </div>
    );
}
